import { Suspense } from 'react';

import { EscrowInvitationDialog, InvitationDetailsSkeleton } from 'src/widgets/EscrowInvitationDialog';

import { useInvitationSearchParam } from '../model';

import InvitationContent from './InvitationContent';

const EscrowInvitationDialogContainer = () => {
  const { invitationId, closeInvitation } = useInvitationSearchParam();

  if (!invitationId) return null;

  return (
    <Suspense
      fallback={
        <EscrowInvitationDialog open onClose={closeInvitation}>
          <InvitationDetailsSkeleton />
        </EscrowInvitationDialog>
      }
    >
      <InvitationContent invitationId={invitationId} onClose={closeInvitation} />
    </Suspense>
  );
};

export default EscrowInvitationDialogContainer;
